<template>
  <article
    class="aroma-product-card"
    role="button"
    tabindex="0"
    @click="$emit('click')"
    @keyup.enter="$emit('click')"
    @keyup.space.prevent="$emit('click')"
  >
    <img
      v-if="hasImage"
      class="aroma-product-card__image"
      :src="image"
      :alt="productName"
      @error="imageFailed = true"
    />
    <div v-else class="aroma-product-card__image aroma-product-card__image--empty">
      <van-icon name="photo-o" size="30" />
    </div>
    <div class="aroma-product-card__body">
      <div class="aroma-product-card__topline">
        <h2>{{ productName }}</h2>
        <strong>￥{{ price }}</strong>
      </div>
      <p>{{ product.description || '改善睡眠，提升睡眠质量' }}</p>
      <span v-if="product.label" class="aroma-product-card__tag">{{ product.label }}</span>
    </div>
  </article>
</template>

<script>
import { formatPrice } from '@/utils/aroma-shop'

export default {
  name: 'AromaProductCard',

  props: {
    product: {
      type: Object,
      required: true
    },
    image: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      imageFailed: false
    }
  },

  computed: {
    hasImage () {
      return Boolean(this.image) && !this.imageFailed
    },

    productName () {
      return this.product.packageName || this.product.catalogName || '商品'
    },

    price () {
      return formatPrice(this.product.packagePrice)
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-product-card {
  display: flex;
  min-height: 132px;
  padding: 14px;
  overflow: hidden;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(58, 64, 78, 0.18);
  box-sizing: border-box;
  cursor: pointer;
  touch-action: manipulation;
  transition: opacity 160ms ease, box-shadow 160ms ease;

  &:active {
    opacity: 0.78;
    box-shadow: 0 1px 3px rgba(58, 64, 78, 0.14);
  }

  &:focus-visible {
    outline: 2px solid #596afd;
    outline-offset: 2px;
  }

  &__image {
    flex: 0 0 104px;
    width: 104px;
    height: 104px;
    object-fit: cover;
    object-position: top;
    background: #f4f4f4;
    border-radius: 4px;
  }

  &__image--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aab0bb;
  }

  &__body {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
    margin-left: 14px;
  }

  &__topline {
    display: flex;
    min-width: 0;
    align-items: baseline;
    gap: 8px;

    h2 {
      min-width: 0;
      flex: 1;
      overflow: hidden;
      color: #1f2329;
      font-size: 17px;
      font-weight: 500;
      line-height: 24px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      color: #ff4c45;
      font-size: 17px;
      font-weight: 600;
      line-height: 24px;
      white-space: nowrap;
    }
  }

  p {
    display: -webkit-box;
    margin: 7px 0 0;
    overflow: hidden;
    color: #8a8f98;
    font-size: 13px;
    line-height: 19px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  &__tag {
    align-self: flex-start;
    margin-top: auto;
    padding: 3px 7px;
    color: #596afd;
    font-size: 11px;
    line-height: 16px;
    background: #eef0ff;
    border-radius: 3px;
  }
}
</style>
